"use client";
import { FormGroup, MultipleSelect, MultipleSelectTypes } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';
import React from 'react';
import { useSelector } from 'react-redux';
import { storeSelectors } from '@/store';

type Props = {
    value: string[],
    handleChange: (event: React.ChangeEvent<any>, values?: string[]) => void
}

const MetricLocalizationsFilter = ({ handleChange, value}: Props) => {
    const { translate } = useTranslations();
    const currentMetricLocalization = useSelector(storeSelectors.selectCurrentMetricLocalization);
    const options: MultipleSelectTypes.MultipleSelectOption<string>[] = 
        currentMetricLocalization?.metricPointPlatforms.map((x) => ({ 
            label: `${x.name}`, 
            value: x.uId, 
            colorVariant: !x.isActive ? "gray" : undefined,
            badge: !x.isActive ? { children: 'Nieaktywny', variant: 'yellow' } : undefined
        } as MultipleSelectTypes.MultipleSelectOption<string>)) ?? [];

    return (
        <FormGroup label={translate('Dostępne punkty preselekcyjne')}>
            <MultipleSelect
                options={options}
                //@ts-ignore
                handleChange={handleChange}
                value={value}
            />
        </FormGroup>
    );
};

export default MetricLocalizationsFilter;